import React from 'react';
import type { FC } from 'react';
import type {
  BuyAgainAddToCartEventPayload,
  BuyAgainOrderItem,
} from '../../../../LoginSocialBar.types';
import { ON_BUY_AGAIN_ADD_TO_CART_EVENT } from '../../../../LoginSocialBar.types';
import styles from './BuyAgain.module.scss';
import { DATA_HOOK } from './constants';
import DotsLoader from './DotsLoader';

interface ProductCardProps {
  item: BuyAgainOrderItem;
  isAdding: boolean;
  addToCartText: string;
  onAddToCart: (event: BuyAgainAddToCartEventPayload) => void;
}

const ProductCard: FC<ProductCardProps> = ({
  item,
  isAdding,
  addToCartText,
  onAddToCart,
}) => {
  return (
    <div
      className={styles['root__product-card']}
      data-testid={DATA_HOOK.productCard}
    >
      <div
        className={styles['root__product-image']}
        data-testid={DATA_HOOK.productImage}
      >
        {item.imageUrl && <img src={item.imageUrl} alt={item.productName} />}
      </div>
      <div className={styles['root__product-info']}>
        <span
          className={styles['root__product-name']}
          data-testid={DATA_HOOK.productName}
        >
          {item.productName}
        </span>
        <span
          className={styles['root__product-price']}
          data-testid={DATA_HOOK.productPrice}
        >
          {item.formattedPrice}
        </span>
      </div>
      <button
        type="button"
        className={styles['root__product-action']}
        data-testid={DATA_HOOK.addToCart}
        disabled={isAdding}
        onClick={e => {
          e.stopPropagation();
          onAddToCart({
            type: ON_BUY_AGAIN_ADD_TO_CART_EVENT,
            catalogItemId: item.catalogItemId,
            ...(item.catalogOptions && {
              catalogOptions: item.catalogOptions,
            }),
          });
        }}
      >
        <span style={isAdding ? { visibility: 'hidden' } : undefined}>
          {addToCartText}
        </span>
        {isAdding && <DotsLoader />}
      </button>
    </div>
  );
};

export default ProductCard;
